import App from "./App.svelte";
import "./lib/i18n.js";

const app = new App({
  target: document.getElementById("app"),
});

export default app;
